import React from 'react';
import ServiceRequestAssignForm from '../../../../ServiceRequest/ServiceRequestAssignForm';
import { updateBulkStatus } from 'src/services/client';
import { selectAuthenticatedUser } from 'src/store/selectors/auth';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import GenericDialogue from 'src/components/Dialogue/Dialogue';

export const AssignedStatusOverlay = ({
  serviceRequests,
  showAssignedStatusOverlay,
  setShowAssignedStatusOverlay,
  fetchDashboard,
}) => {
  const serviceRequestIds = serviceRequests.map((sr) => ({ id: sr.id }));
  const user = useSelector(selectAuthenticatedUser);

  const handleStatusChange = async (data) => {
    setShowAssignedStatusOverlay(false);

    const res: any = await updateBulkStatus({
      serviceRequest: serviceRequestIds,
      name: 'Assigned',
      userId: user.id,
      ServiceProviderId: data.userId,
    });

    if (res.status !== 200) {
      toast.error(
        '🚫 Failed to update service requests, please try again later.',
        { autoClose: 5000, position: 'top-center' }
      );
      return;
    }

    toast.success('Service requests updated successfully', {
      autoClose: 5000,
      position: 'top-center',
    });
    fetchDashboard();
  };

  return (
    <GenericDialogue
      isOpen={showAssignedStatusOverlay}
      onClose={() => setShowAssignedStatusOverlay(false)}
      title="Assign Status"
      maxWidth="100rem"
    >
      <ServiceRequestAssignForm
        from="dashboard"
        serviceRequest={{
          ...serviceRequests[0],
          serviceType: serviceRequests[0]?.type,
          ticketId: serviceRequests[0]?.ticketNumber,
        }}
        onClose={() => setShowAssignedStatusOverlay(false)}
        handleStatusChange={(data) => handleStatusChange(data)}
        isLegacyTable={false}
        serviceRequestsToUpdate={serviceRequests}
      />
    </GenericDialogue>
  );
};
